const bcImageResize = (baseImage, size) => {
    if (!baseImage) return ''
    // match end of baseImage pattern e.g. /377x212/match/image.jpg (377x212 in this case)
    const regex = /\/\d+x\d+\//;
    if (regex.test(baseImage)) {
        return baseImage.replace(regex, '/' + size + '/')
    }
    return baseImage
}

  const formatDuration = (duration) => {
    if (!duration) return '';
    if (typeof duration === 'string' && duration.includes(':')) return duration;
    const milliseconds = parseInt(duration, 10);
    if (isNaN(milliseconds)) return '';
    const seconds = Math.round(milliseconds / 1000);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return hours > 0
      ? `${hours}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
      : `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  export { bcImageResize, formatDuration };